<template>
    <div class="BLM-info">
        <div>{{ label }}:</div>
        <div v-if="value">{{ value }}</div>
        <slot></slot>
    </div>
</template>
<script>
export default {
  name: 'InfoItem',
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
  },
}
</script>
<style lang="scss" scoped>
.BLM-info{
    display:flex;
    font-size:14px;
    margin-bottom:10px;
    font-weight: 500;
    align-items: center;
    &>div:nth-child(1) {
        margin-right:5px
    }
}
</style>
